import { Injectable } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { SessionService } from '@monsido/core/session/session.service';
import { ForethoughtProvider } from '@client/app/modules/chat/forethought/provider/forethought.provider';
import { EventsType } from '@monsido/services/mon-event/events.type';

@Injectable({
    providedIn: 'root',
})
export class ForethoughtRunService {
    constructor (
        private monEventService: MonEventService,
        private forethoughtProvider: ForethoughtProvider,
        private sessionService: SessionService,
    ) {}

    public setupEventListeners (): void {
        this.monEventService.addListener('afterCustomer' as EventsType, () => {
            if (this.sessionService.getChatSystem() === 'forethought' && !this.sessionService.isSudo) {
                this.forethoughtProvider.addScript();
            }
        });
    }
}
